import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from '../apiroutes';
import { ContainerSizeType } from 'src/app/models/container_master_model/sizeType';
import { BackendListModel } from '../../models/common/list.model';
import { catchError, map, Observable, Subject, tap, throwError } from 'rxjs';
import { DepotMasterTab2 } from 'src/app/models/depot-master-model';
import { ContactsModel } from 'src/app/models/contacts';
import { DepotMasterTab3 } from 'src/app/models/depot-master-tab3';
import { StorageCharge } from 'src/app/models/Depot_Master_Model/storage-charge';
import { ManHourCharge } from 'src/app/models/Depot_Master_Model/man-hour-charge';
import { OperationalCharges } from 'src/app/models/Depot_Master_Model/operational-charges';
import { OperationalChargesArray } from 'src/app/models/Depot_Master_Model/operational-charges-array';
import { ManHourChargesarray } from 'src/app/models/Depot_Master_Model/man-hour-chargesarray';
import { Locationdocuments } from 'src/app/models/Depot_Master_Model/locationdocuments';
import { DepotMasterTab1 } from 'src/app/models/Depot_Master_Model/depot-master-tab1';
import { Locationport } from 'src/app/models/Depot_Master_Model/locationport';
import { LocationConnectivityModel } from 'src/app/models/location-connectivity-model';
import { ContainerSize } from 'src/app/models/Depot_Master_Model/container-size';
import { Charge } from 'src/app/models/Depot_Master_Model/charge';
import { Depotcontainertypegroup } from 'src/app/models/Depot_Master_Model/depotcontainertypegroup';
import { IChargeMasterModel } from 'src/app/models/Charge_Master_Model/charge-master';

@Injectable({
  providedIn: 'root'
})
export class DepotMasterApiService {
  base_url = ApiRoutes.DepotMaster;
  base_url1 = ApiRoutes.ContainerMaster;
  geo_url = ApiRoutes.Geo;
  depotSubject = new Subject<{}>();
  contactSubject = new Subject<{}>();

  constructor(private http: HttpClient
  ) { }

  depotCreateTab1(data: DepotMasterTab1) {
    let url = `${this.base_url}location/`;
    return this.http.post(url, data);
  }

  updateDepotTab1(deptId: string, data: DepotMasterTab1) {
    let url = `${this.base_url}location/${deptId}/`;
    return this.http.put(url, data);
  }

  getDepotTab1(id): Observable<BackendListModel<DepotMasterTab1>> {
    let url = `${this.base_url}depot_create/tab1/${id}/`;
    return this.http.get<BackendListModel<DepotMasterTab1>>(url);
  }

  depotCreateTab2(depot: DepotMasterTab2, id) {
    let url = `${this.base_url}depot_create/tab2/${id}/`;
    console.log(depot);
    return this.http.put(url, depot);
  }

  getDepotTab2(id): Observable<BackendListModel<DepotMasterTab2>> {
    let url = `${this.base_url}depot_create/tab2/${id}/`;
    return this.http.get<BackendListModel<DepotMasterTab2>>(url);
  }

  depotCreateTab3(depot: DepotMasterTab3, id) {
    let url = `${this.base_url}depot_create/tab3/${id}/`;
    console.log(depot);
    return this.http.put(url, depot);
  }

  //Previous API
  depotStoragecharge(storage: StorageCharge, id) {
    let url = `${this.base_url}depot_create/tab3/${id}/storage_charge/`;
    console.log(storage);
    return this.http.put(url, storage);
  }
  getdepotStoragecharge(depotId: string) {
    let url = `${this.base_url}depot_create/tab3/${depotId}/storage_charge/`;
    // console.log(storage);
    return this.http.get<StorageCharge>(url);
  }

  // getDepotMasterbyID(depotId: string) {
  //   let url = `${this.base_url}location/${depotId}/`;
  //   return this.http.get<DepotMasterTab1>(url);
  // }
  //New API
  postdepotStorageCharge(storage: StorageCharge, id) {
    storage['charge_pulse'] = 2000;
    let url = `${this.base_url}depot_create/tab3/${id}/storage_charge/`;
    return this.http.put(url, storage);
  }

  updatedepotStorageCharge(storage: StorageCharge, id) {
    let url = `${this.base_url}depot_create/tab3/${id}/storage_charge/${storage.id}`;
    return this.http.put(url, storage);
  }

  putdepotManHourcharge(ManHourCharge: ManHourChargesarray, id) {
    let url = `${this.base_url}depot_create/tab3/${id}/man_hour_charge/`;
    console.log(ManHourCharge);
    return this.http.put(url, ManHourCharge);
  }

  postdepotManHourcharge(manHourCharge: ManHourCharge) {
    let url = `${this.base_url}depotmanhourchargedetails/`;
    console.log(manHourCharge);
    return this.http.post(url, manHourCharge);
  }

  // GET operational charge Table Structure
  getOperationalChargeTableStructure(): Observable<any> {
    let url = `${this.base_url}depot_operational_charges_data/`
    return this.http.get(url);
  }

  // GET operational charge Table data
  getOperationalChargeDataByDepotId(depotId): Observable<BackendListModel<any>> {
    let url = `${this.base_url}depot_operational_charges_combined/${depotId}/`;
    return this.http.get<BackendListModel<any>>(url);
  }

  // POST operational charges
  postOperationalcharge(operationalCharge: OperationalCharges) {
    let url = `${this.base_url}depotsoperationalcharges/`;
    console.log(operationalCharge);
    return this.http.post(url, operationalCharge);
  }

  // PUT operational charges
  putOperationalcharge(operationalCharge) {
    let url = `${this.base_url}depotsoperationalcharges/${operationalCharge.id}/`;
    return this.http.put(url, operationalCharge);
  }

  // DELETE operational charges
  deleteOperationalcharge(id: string) {
    let url = `${this.base_url}depotsoperationalcharges/${id}/`;
    return this.http.delete(url);
  }

  // GET Depot Optional Charges
  getOptionalDepotCharges(depotId, charge_type = 'Depot Optional'): Observable<BackendListModel<IChargeMasterModel>> {
    let url = `${this.base_url}charges/`;
    let urlObj = new URL(url);

    urlObj.searchParams.append('charge_type', String(charge_type));
    urlObj.searchParams.append('depot_id', String(depotId));
    return this.http.get<BackendListModel<IChargeMasterModel>>(String(urlObj));
  }

  getOperationalcharge(): Observable<BackendListModel<OperationalCharges>> {
    let url = `${this.base_url}depotsoperationalcharges/`;
    return this.http.get<BackendListModel<OperationalCharges>>(url);
  }

  postdepotCreateContacts(contact: ContactsModel) {
    let url = `${this.base_url}contacts/`;
    return this.http.post(url, contact);
  }

  updatedepotContacts(contact: ContactsModel) {
    let url = `${this.base_url}contacts/${contact.id}/`;
    return this.http.put(url, contact);
  }

  getContactDetails(id): Observable<BackendListModel<ContactsModel>> {
    let url = `${this.base_url}location/${id}/contacts/`;
    return this.http.get<BackendListModel<ContactsModel>>(url);
  }

  postLocationDocuments(data: Locationdocuments) {
    let url = `${this.base_url}locationdocuments/`;
    return this.http.post(url, data);
  }

  updateLocationDocuments(data: Locationdocuments, locId: string) {
    let url = `${this.base_url}locationdocuments/${locId}/`;
    return this.http.put(url, data);
  }

  deleteLocationDocuments(locId: string) {
    let url = `${this.base_url}locationdocuments/${locId}/`;
    return this.http.delete(url);
  }

  getLocationDocuments(): Observable<BackendListModel<Locationdocuments>> {
    let url = `${this.base_url}locationdocuments/`;
    return this.http.get<BackendListModel<Locationdocuments>>(url);
  }

  getLocationDocumentsbyId(depotId, order = '') {
    let url = `${this.base_url}locationdocuments/${depotId}/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('o', String(order));
    return this.http.get<DepotMasterTab1>(String(urlObj));
  }
  // getLocationDocumentsbyid1(id): Observable<BackendListModel<Locationdocuments>> {
  //   let url = `${this.base_url}${id}/documents/`;
  //   return this.http.get<BackendListModel<Locationdocuments>>(url);
  // }

  // getLocationDocumentsbyid(id): Observable<BackendListModel<Locationdocuments>> {
  //   let url = `${this.base_url}locationdocuments/${id}`;
  //   return this.http.get<BackendListModel<Locationdocuments>>(url);
  // }

  // getDepotTab1byID(id): Observable<BackendListModel<Locationdocuments>> {
  //   let url = `${this.base_url}locationdocuments/${id}/`;
  //   return this.http.get<BackendListModel<Locationdocuments>>(url);
  // }

  postLocationportMapping(locationport: Locationport) {
    let url = `${this.base_url}locationportmapping/`;
    return this.http.post(url, locationport);
  }

  updateLocationportMapping(locationport: Locationport) {
    let url = `${this.base_url}locationportmapping/${locationport.id}/`;
    return this.http.put(url, locationport);
  }

  getLocationportMapping(id): Observable<BackendListModel<Locationport>> {
    let url = `${this.base_url}locationportmapping/${id}/`;
    return this.http.get<BackendListModel<Locationport>>(url);
  }

  // getDocandContactsList(id): Observable<DepotMasterTab2> {
  //   let url = `${this.base_url}depot_create/tab2/${id}/`;
  //   return this.http.get<DepotMasterTab2>(url);
  // }

  getApproachableVia(DepotId = null): Observable<BackendListModel<LocationConnectivityModel>> {
    let url = new URL(`${this.base_url}location_connectivity_master/`);
    if (DepotId) {
      url.searchParams.append('location_id', DepotId);
    }
    return this.http.get<BackendListModel<LocationConnectivityModel>>(url.toString());
  }

  getDepotMasterbyID(depotId, order = '') {
    let url = `${this.base_url}location/${depotId}/`;
    let urlObj = new URL(url);
    urlObj.searchParams.append('o', String(order));
    return this.http.get<DepotMasterTab1>(String(urlObj));
  }

  //get Container size type
  getContainerSizeType(): Observable<BackendListModel<ContainerSize>> {
    let url = `${this.base_url1}size/`;
    return this.http.get<BackendListModel<ContainerSize>>(url);
  }

  //get Container charges
  getContainerCharges(): Observable<BackendListModel<Charge>> {
    let url = `${this.base_url}charges/`;
    return this.http.get<BackendListModel<Charge>>(url);
  }

  //get Depot Container Type Group
  getDepotContainerTypeGroup(): Observable<BackendListModel<Depotcontainertypegroup>> {
    let url = `${this.base_url}depotcontainertypegroup/`;
    return this.http.get<BackendListModel<Depotcontainertypegroup>>(url);
  }
  //getPorts
  getDepotPorts(): Observable<BackendListModel<Locationport>> {
    let url = `${this.base_url}location/?location_type_name=depot`;
    return this.http.get<BackendListModel<Locationport>>(url);
  }

  updateDepotSubjectValue(depot): void {
    this.depotSubject.next(depot);
  }

  getCurrencybyCountryId(id): Observable<BackendListModel<any>> {
    let url = `${this.geo_url}country_currency/${id}/`;
    return this.http.get<BackendListModel<any>>(url);
  }

  updateContactSubjectValue(contact): void {
    this.contactSubject.next(contact);
  }
}
